import React from "react"; 
import HomeContentLogos from "../homePage/homeContentLogos";
import data from "../../data";
import HomeContentOthers from "../homePage/homeContentOthers";
import { Link } from "react-router-dom";

function Home(props) {
    const info = data.about.info
    const image = data.about.info.links.map(item => {
        return (
            <HomeContentLogos key={item.name}
            {...item} />  
        )
    })

    const otherInfo = data.about.info.others.map(item => {
        return (
            <HomeContentOthers key={item.link} {...item} />
        )
    })

    const handleLinkClick = () => {
      window.scrollTo(0, 0);
    };
    
    return (
        <main className={`home ${props.darkMode ? "dark" : ""}` }>
            <section className="logo">
                <article>
                    <section className="logo_content">
                        <article>
                            <div className="logo_content-info">
                                <h2>{info.title}</h2>
                                <h3>{info.position}</h3>
                                <p>{info.desc}</p>
                                <h4>Skills and Tools used</h4>
                                {image}
                            </div>
                            <div className="logo_content-info">
                            <h3><Link to="/resume" onClick={handleLinkClick}>My Resume link</Link></h3>
                                {otherInfo}
                            </div>
    
                        </article>
                        
                    </section>
                </article>
            </section>
        </main>
    )
}


export default Home
